<template>
    <b-container fluid>
      <PortalNavbar show="true"></PortalNavbar>
 <section class="faq_area row" style="margin-left:50px;">
<div class="container">
<!--<div class="tittle wow fadeInUp">
<h2>FAQs</h2>
</div>-->
<div class="row faq_row">
<div class="who_we_area col-md-12">
<div class="subtittle">
<h2 style="color:#ec5624;">FAQs</h2>
</div><br/><br/>

<div class="col-md-12" style="margin-left:;">
<button class="collapsible">What are the educational qualifications required for the post of security Guard?</button>
<div class="content">
  <p><li>The applicant must be at least passed in 8th standard.</li><p/>
</div>

<button class="collapsible">What are the physical qualifications?</button>
<div class="content">
  <p> 
    <ui>For Male candidate: 
      <li>minimum height of 162 cm.</li> 
      <li>minimum weight of 50 kg. </li>
      <li>Chest (deflated) 79 cm. minimum</li>
      <li>Chest (Inflated) 84 cm. minimum</li>

    </ui>
    <br/>
    <ui>For Female candidate: 
      <li>minimum height of 155 cm.</li>
      <li>minimum weight of 48 kg.</li>
    </ui>
  <p/>
</div>

<button class="collapsible">What is the age limit for recruitment of the Security Guard?</button>
<div class="content">
  <p> 
    <li>For General category candidates, age should be between 18 to 33 yrs.</li>
    <li>For SC/ST/OBC/SEBC category candidates, age should be between 18 to 38 yrs.</li>
	  <li>Certified Security Guard does not have age condition.</li>
	  <li>Ex-Serviceman has age limit of 45 yrs.</li>
	  <!-- <li>for female applicants also above criteria are applicable .</li> -->
<p/>

</div>

<button class="collapsible">What are the outdoor tests?</button> 
<div class="content">
 <p> <li>Sprint - 400 mtr. For Male
          <ul style="margin-left:5%;"><li>1min. 30 sec. - 12 marks;</li>
              <li>1 min. 35 sec. - 10 marks;</li>
	            <li>1 min. 40 sec. - 8 marks;</li>
	            <li>1 min. 45 sec. - 6 marks;</li>
              <li>1 min. 50 sec. - 4 marks;</li>
	            <li>1 min. 55 sec. - 2 marks;</li>
          </ul>
      </li>
	   
	    <li>Sprint - 200 mtr. For Female
          <ul style="margin-left:5%;"><li>1min. 30 sec. - 12 marks;</li>
              <li>1 min. 35 sec. - 10 marks;</li>
	            <li>1 min. 40 sec. - 8 marks;</li>
	            <li>1 min. 45 sec. - 6 marks;</li>
              <li>1 min. 50 sec. - 4 marks;</li>
	            <li>1 min. 55 sec. - 2 marks;</li>
          </ul>
      </li>

      <ui>
        <li> For Male, 8 PULLUPS - 8 Marks</li> 
        <li> for Female, 4 PULLUPS - 8 Marks</li>
      </ui>
      <ui>
        <li> For Male, 10 SITUPS - 10 Marks</li>
        <li> For Female, 10 SITUPS - 10 Marks</li>
      </ui>
      <li>To pass the outdoor test, the candidate must get atleast 20 marks.</li>
<p/>
</div>

<button class="collapsible">Are there any Medical Examination?</button>
<div class="content">
  <p><li>The candidate must pass the medical examination of the Security Guards Board.
        Colour Blind candidates are not qualified for registration.</li><p/>
</div>

</div>

</div>
</div>
</div>
</section>

        
    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>

.faq_area .faq_row {
  padding-top: 70px;
  padding-bottom: 70px;
}
.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 80px;
  background: #222222;
  left: 0;
  bottom: -22px;
}

.collapsible {
  background-color:#2e4b90;
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 96%;
  border: none;
  text-align: left;
  outline: none;
  font: 400 16px/26px "Open sans", sans-serif;
  margin-bottom:2px;
 

}



.content {
  padding: 0 18px;
  display: block; 
  overflow: hidden;
  width:70%; 

font: 400 14px/26px "Open sans", sans-serif;
color: #555555;
}


.content li{
font: 400 14px/26px "Open sans", sans-serif;
color: #555555;
	 
}

.content p{
font: 400 14px/26px "Open sans", sans-serif;
color: #555555;
padding-top: 18px;
padding-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Portal/Faq.vue